import { render, staticRenderFns } from "./SalesDetail.vue?vue&type=template&id=2782e5de&scoped=true&"
import script from "./SalesDetail.vue?vue&type=script&lang=js&"
export * from "./SalesDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalesDetail.vue?vue&type=style&index=0&id=2782e5de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2782e5de",
  null
  
)

export default component.exports